import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "account-order-detail" }
const _hoisted_2 = { class: "account-order-detail__container" }
const _hoisted_3 = { class: "account-order-detail__list" }
const _hoisted_4 = { class: "account-order-detail__item" }
const _hoisted_5 = {
  key: 0,
  class: "account-order-detail__item-title"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "account-order-detail__item-title-bold" }, "18 февраля", -1)
const _hoisted_7 = { class: "account-order-detail__card-list" }
const _hoisted_8 = { class: "account-order-detail__card-item-left" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "account-order-detail__card-item-right" }
const _hoisted_11 = { class: "account-order-detail__card-item-title" }
const _hoisted_12 = {
  key: 0,
  class: "account-order-detail__card-item-gramm"
}
const _hoisted_13 = { class: "account-order-detail__card-item-info" }
const _hoisted_14 = { class: "account-order-detail__card-item-price" }
const _hoisted_15 = { class: "account-order-detail__card-item-count" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        _createElementVNode("li", _hoisted_4, [
          false
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createTextVNode(" Доставим "),
                _hoisted_6
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("ul", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.source.basket, (item, key) => {
              return (_openBlock(), _createElementBlock("li", {
                class: "account-order-detail__card-item",
                key: key
              }, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("img", {
                    class: "account-order-detail__card-item-img",
                    src: item.images.length>0?item.images[0]:_ctx.noPhoto,
                    width: "103",
                    alt: ""
                  }, null, 8, _hoisted_9)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, _toDisplayString(item.name), 1),
                  false
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, " 460 г • 17 900 ₽ / кг "))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, _toDisplayString(item.ratioPrice) + " ₽ ", 1),
                    _createElementVNode("div", _hoisted_15, _toDisplayString(item.quantity) + " " + _toDisplayString(item.measure), 1)
                  ])
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}